// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height {\n  position: relative;\n  height: 100%;\n}\n.el-dialog__body {\n  padding: 15px !important;\n}\n.no-tax-price {\n  font-size: 17px;\n  color: blue;\n  font-weight: bold;\n}\n.tax-price {\n  font-size: 17px;\n  color: green;\n  font-weight: bold;\n  display: inline-block;\n  width: 100%;\n  text-align: right;\n}\n.link {\n  font-size: 20px;\n  color: skyblue;\n  margin: 5px;\n  cursor: pointer;\n}\n.link :hover {\n  color: blue;\n}\n", ""]);
// Exports
module.exports = exports;
